const myTransactions = {
  selectDateRage:'Выберите диапазон дат',
  selectTransactionType:'Выберите тип транзакции',
  selectApplication:'Выберите приложение',
  export:'Экспорт',
};

export default myTransactions;
